import i18n from "@/i18n";
const routes = {
  path: "/setting",
  name: "Setting",
  component: () =>
    import(/* webpackChunkName: "setting" */ "@/views/setting/Main"),
  children: [
    {
      path: "Profile",
      alias: "",
      name: "Profile",
      component: () =>
        import(/* webpackChunkName: "setting" */ "@/views/setting/Profile"),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.setting.profile"),
        step: [i18n.t("menu.setting.setting"), i18n.t("page.setting.profile")],
        menu_num: 4,
        sub_menu_num: 41,
        location: "/setting/Profile",
      },
    },
    {
      path: "passwordchange",
      name: "PasswordChange",
      component: () =>
        import(
          /* webpackChunkName: "setting" */ "@/views/setting/PasswordChange"
        ),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.setting.password_change"),
        step: [
          i18n.t("menu.setting.setting"),
          i18n.t("page.setting.password_change"),
        ],
        menu_num: 4,
        sub_menu_num: 42,
        location: "/setting/passwordchange",
      },
    },
    {
      path: "emailchange",
      name: "EmailChange",
      component: () =>
        import(/* webpackChunkName: "setting" */ "@/views/setting/EmailChange"),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.setting.email_change"),
        step: [
          i18n.t("menu.setting.setting"),
          i18n.t("page.setting.email_change"),
        ],
        menu_num: 4,
        sub_menu_num: 43,
        location: "/setting/emailchange",
      },
    },
    {
      path: "option",
      name: "Option",
      component: () =>
        import(/* webpackChunkName: "setting" */ "@/views/setting/Option"),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.setting.option"),
        step: [i18n.t("menu.setting.setting"), i18n.t("page.setting.option")],
        menu_num: 4,
        sub_menu_num: 44,
        location: "/setting/option",
      },
    },
    {
      path: "notice",
      name: "Notice",
      component: () =>
        import(/* webpackChunkName: "setting" */ "@/views/setting/Notice"),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.setting.owner_notice"),
        step: [
          i18n.t("menu.setting.setting"),
          i18n.t("page.setting.owner_notice"),
        ],
        menu_num: 4,
        sub_menu_num: 45,
        location: "/setting/notice",
      },
    },
    {
      path: "noticeview/:noticeno",
      name: "NoticeView",
      component: () =>
        import(/* webpackChunkName: "setting" */ "@/views/setting/NoticeView"),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.brandroom.owner_notice_view"),
        step: [
          i18n.t("menu.setting.setting"),
          i18n.t("menu.setting.owner_notice"),
        ],
        menu_num: 4,
        sub_menu_num: 45,
        location: "/setting/notice",
      },
    },
  ],
};

export default routes;
